import Pagination from '@/domain/pagination.entity'
import axios from 'axios';
import ContractNotBilledFilter from '../entity/contract-not-billed-filter.entity';
import Response from '../../response.entity';

export default class ContractNotBilledService {
  public static filter(
    pagination: Pagination,
    businessUnitId: string,
    filter: ContractNotBilledFilter,
  ) {
    return axios.get(`/api/v1/business-units/${businessUnitId}/contracts/not-billed`, {
      params: {
        page: pagination.page - 1,
        size: pagination.itemsPerPage,
        sortBy: pagination.arrangeSortBy,
        versionExternalId: filter.externalId ? filter.externalId : null,
        resultCenterId: filter.resultCenterId ? filter.resultCenterId : null,
        beneficiaryId: filter.beneficiaryId ? filter.beneficiaryId : null,
        customerId: filter.customerId ? filter.customerId : null,
        contractNumber: filter.contractNumber ? filter.contractNumber : null,
        customerDocument: filter.customerDocument ? filter.customerDocument : null,
        competence: filter.competence ? filter.competence : null,
      },
    })
      .then((resp) => Response.of(resp.data))
  }
}
